import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import vGallery from 'v-gallery'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueAnalytics from 'vue-analytics'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

const isProd = process.env.NODE_ENV === 'production'
const disabledCookies = Vue.cookies.get('rc-cookies-disabled') === 'true' || !Vue.cookies.get('rc-cookies-disabled')

Vue.use(VueAnalytics, {
  id: 'UA-37601255-1',
  disabled: disabledCookies,
  router: router,
  autoTracking: {
    page: true,
    pageviewOnLoad: true
  },
  debug: {
    enabled: !isProd,
    trace: !isProd
  }
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAvvaVlAI9msB8cydG59BPFaTSb1s6Zyp8',
    libraries: 'places' // necessary for places input
  }
})

Vue.use(Vuetify)
Vue.use(vGallery)
Vue.use(Vuelidate)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
